export default __webpack_public_path__ + "static/media/logo-near-icon.df006c52.png";